// extracted by mini-css-extract-plugin
module.exports = {"GrayBackgroundFollows":"GrayBackgroundFollows_GrayBackgroundFollows__3prm0"};